/* ROUTES COMPONENT
   ========================================================================== */

import { RouteObject } from 'react-router-dom';

import loadable from '@loadable/component';
import LayoutDefault from 'containers/layouts/default';
import Loading from 'containers/loadable-fallback/loading';

import ROUTES from './constant';
import { ProtectedRoute } from './protected.route';

/**
 * Lazy load page components. Fallback to <Loading /> when in loading phase
 */
const Home = loadable(() => import('pages/home'), { fallback: <Loading /> });
const Community = loadable(() => import('pages/community'), { fallback: <Loading /> });
const CreateTickers = loadable(() => import('pages/create-stickers'), { fallback: <Loading /> });
const ListMarketSticker = loadable(() => import('pages/list-market-sticker'), {
  fallback: <Loading />,
});
const ListOwnerSticker = loadable(() => import('pages/list-owner-sticker'), {
  fallback: <Loading />,
});
const NFTSales = loadable(() => import('pages/nft-sale'), {
  fallback: <Loading />,
});
const Messages = loadable(() => import('pages/messages'), { fallback: <Loading /> });
const MessageDefault = loadable(() => import('pages/messages/message-content/default'), {
  fallback: <Loading />,
});
const Notification = loadable(() => import('pages/messages/mobile/notification-list'), {
  fallback: <Loading />,
});
const UserInfo = loadable(() => import('pages/messages/mobile/user'), {
  fallback: <Loading />,
});
const Wallet = loadable(() => import('pages/messages/mobile/wallet-list'), {
  fallback: <Loading />,
});
const ChatContent = loadable(() => import('pages/messages/message-content'), {
  fallback: <Loading />,
});
const PreRegistration = loadable(() => import('pages/pre-registration'), { fallback: <Loading /> });
const Error = loadable(() => import('pages/error'), { fallback: <Loading /> });
const Maintenance = loadable(() => import('pages/maintenance'), { fallback: <Loading /> });
const PCAvailable = loadable(() => import('pages/error/available'), { fallback: <Loading /> });
const SnsPage = loadable(() => import('pages/sns'), { fallback: <Loading /> });

/**
 * Use <AuthRoute /> to protect authenticate pages
 */
export const blockAccessRoutes: RouteObject[] = [
  {
    path: ROUTES.home,
    element: <LayoutDefault />,
    children: [
      { path: ROUTES.home, element: <Home /> },
      { index: true, element: <Home /> },
      { path: ROUTES.linkTelegram, element: <Home /> },
    ],
  },
  { path: ROUTES.preRegistration, element: <PreRegistration /> },
  { path: ROUTES.notfound, element: <Error /> },
  {
    path: ROUTES.available,
    element: <PCAvailable />,
  },
];

export const fullAccessRoutes: RouteObject[] = [
  {
    path: ROUTES.home,
    element: <LayoutDefault />,
    children: [
      {
        path: ROUTES.createStickers,
        element: (
          <ProtectedRoute redirectPath={ROUTES.home}>
            <CreateTickers />
          </ProtectedRoute>
        ),
      },
      { path: ROUTES.listMarketStickers, element: <ListMarketSticker /> },
      {
        path: ROUTES.listOwnerStickers,
        element: (
          <ProtectedRoute redirectPath={ROUTES.home}>
            <ListOwnerSticker />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTES.nftSale,
        element: (
          <ProtectedRoute redirectPath={ROUTES.home}>
            <NFTSales />
          </ProtectedRoute>
        ),
      },
      { path: ROUTES.home, element: <Home /> },
      { index: true, element: <Home /> },
      { path: ROUTES.linkTelegram, element: <Home /> },
    ],
  },
  { path: ROUTES.preRegistration, element: <PreRegistration /> },
  { path: ROUTES.wallet, element: <Wallet /> },
  { path: ROUTES.notfound, element: <Error /> },
  {
    path: ROUTES.messages,
    element: (
      <ProtectedRoute redirectPath={ROUTES.home}>
        <Messages />
      </ProtectedRoute>
    ),
    children: [
      { path: ROUTES.chatThread, element: <ChatContent /> },
      { path: '', element: <MessageDefault /> },
      { path: ROUTES.notification, element: <Notification /> },
      { path: ROUTES.user, element: <UserInfo /> },
      { path: ROUTES.community, element: <Community /> },
    ],
  },
  {
    path: ROUTES.available,
    element: <PCAvailable />,
  },
  { path: ROUTES.discordConnect, element: <SnsPage /> },
];

export const routesMode: RouteObject[] = [{ path: ROUTES.maintenance, element: <Maintenance /> }];
